export const freeplayInitialState = {
    freeplay: {
      studentName: '',
      friendName: '',
      selectedStudentCharacter: null,
      selectedFriendCharacter: null,
      coins: 0,
      level1: null,
      level1Decorate: null,
      level1Coin: 0,
      level2: null,
      level2Decorate: null,
      level2Coin: 0,
      level2SharedCoin:0,
      level3: null,
      level3Decorate: null,
      level3Coin: 0,
      level3SharedCoin:0,
      level4: null,
      level4Decorate: null,
      level4Coin: 0,
      level4SharedCoin:0,
    },
  };
  
  export const FreePlayReducer = (state = freeplayInitialState, action) => {
    switch (action.type) {
      case 'SET_FREEPLAY_LEVEL1_INITIALSTATE': {  
        let level1tempObj = action.payload?.progress;
        if (!level1tempObj) {
            level1tempObj = {favorite:{color:{unlocked:0}, animal:{unlocked:0}, food:{unlocked:0}, game:{unlocked:0}, thing:{unlocked:0}}, 
            feeling:{happy:{unlocked:0}, nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, calm:{unlocked:0}, confident:{unlocked:0}},
            listening:{happy:{unlocked:0}, nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, calm:{unlocked:0}, confident:{unlocked:0}},
            friends:{outside:{unlocked:0}, animal:{unlocked:0}, food:{unlocked:0}, fun:{unlocked:0}, subject:{unlocked:0}},
            solution:{nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}},
            conflict:{seat:{unlocked:0}, shop:{unlocked:0}, shovel:{unlocked:0}, stand:{unlocked:0}, photo:{unlocked:0}},
            advocacy:{bird:{unlocked:0}, train:{unlocked:0}, monkey:{unlocked:0}, care:{unlocked:0}, snack:{unlocked:0}},
            community:{cone:{unlocked:0}, guard:{unlocked:0}, wheel:{unlocked:0}, arcade:{unlocked:0}, food:{unlocked:0}, grocery:{unlocked:0}, salon:{unlocked:0}, clothing:{unlocked:0}, bakery:{unlocked:0}, theater:{unlocked:0}}}
        }
        let level1DecorateTempObj = action.payload?.decorate;
        if (!level1DecorateTempObj) {
            level1DecorateTempObj = {background: 0, items:[]}
        }

        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1: level1tempObj,
            level1Decorate: level1DecorateTempObj,
            level1Coin: action.payload?.coin ? action.payload?.coin : 0,
            // {name: 'BeachChairBlue', url: 'images/Module1Images/Reward_ChairBlue.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'BeachChairRed', url: 'images/Module1Images/Reward_ChairRed.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'BeachwearSandles', url: 'images/Module1Images/Reward_Shoes.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'BeachwearSnorkle', url: 'images/Module1Images/Reward_Googels.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'FloatationBall', url: 'images/Module1Images/Reward_BeachBall.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'SandBucket', url: 'images/Module1Images/Reward_Bucket.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'CrabWearGlasses', url: 'images/Module1Images/Reward_Glasses.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'CrabWearMustache', url: 'images/Module1Images/Reward_Mustache.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'SandCastle', url: 'images/Module1Images/Reward_SandCastel.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'SeashellsRed', url: 'images/Module1Images/Reward_StarFish.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'OceanBoat', url: 'images/Module1Images/Reward_Ship.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'SeashellsGreen', url: 'images/Module1Images/Reward_Shell.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'SurfBoardBlue', url: 'images/Module1Images/Reward_SurfBoardBlue.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'SurfBoardRed', url: 'images/Module1Images/Reward_SurfBoardRed.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'UmbrellaGreen', url: 'images/Module1Images/Reward_UmbrellaGreen.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'UmbrellaRed', url: 'images/Module1Images/Reward_UmbrellaRed.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'FloatationInnerTube', url: 'images/Module1Images/Reward_Floaty.svg', position: {x: 0.4, y: 0.4}, coin: 1},
            // {name: 'OceanWhale', url: 'images/Module1Images/Reward_Whale.svg', position: {x: 0.4, y: 0.4}, coin: 1},
          },
        };
      }

      case 'SET_FREEPLAY_LEVEL2_INITIALSTATE': {  
        let level2tempObj = action.payload?.progress;
        if (!level2tempObj) {
            level2tempObj = {favorite:{color:{unlocked:0}, animal:{unlocked:0}, food:{unlocked:0}, game:{unlocked:0}, thing:{unlocked:0}}, 
            feeling:{happy:{unlocked:0}, nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, calm:{unlocked:0}, confident:{unlocked:0}},
            listening:{happy:{unlocked:0}, nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, calm:{unlocked:0}, confident:{unlocked:0}},
            friends:{outside:{unlocked:0}, animal:{unlocked:0}, food:{unlocked:0}, fun:{unlocked:0}, subject:{unlocked:0}},
            solution:{nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}},
            conflict:{seat:{unlocked:0}, shop:{unlocked:0}, shovel:{unlocked:0}, stand:{unlocked:0}, photo:{unlocked:0}},
            advocacy:{bird:{unlocked:0}, train:{unlocked:0}, monkey:{unlocked:0}, care:{unlocked:0}, snack:{unlocked:0}},
            community:{cone:{unlocked:0}, guard:{unlocked:0}, wheel:{unlocked:0}, arcade:{unlocked:0}, food:{unlocked:0}, grocery:{unlocked:0}, salon:{unlocked:0}, clothing:{unlocked:0}, bakery:{unlocked:0}, theater:{unlocked:0}}}
        }

        let level2DecorateTempObj = action.payload?.decorate;
        if (!level2DecorateTempObj) {
            level2DecorateTempObj = {background: 0, items:[]}
        }

        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level2: level2tempObj,
            level2Decorate: level2DecorateTempObj,
            level2Coin: action.payload?.coin ? action.payload?.coin : 0,
          },
        };
      }

      case 'SET_FREEPLAY_LEVEL3_INITIALSTATE': {  
        let level3tempObj = action.payload?.progress;
        if (!level3tempObj) {
            level3tempObj = {favorite:{color:{unlocked:0}, animal:{unlocked:0}, food:{unlocked:0}, game:{unlocked:0}, thing:{unlocked:0}}, 
            feeling:{happy:{unlocked:0}, nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, calm:{unlocked:0}, confident:{unlocked:0}},
            listening:{happy:{unlocked:0}, nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, calm:{unlocked:0}, confident:{unlocked:0}},
            friends:{outside:{unlocked:0}, animal:{unlocked:0}, food:{unlocked:0}, fun:{unlocked:0}, subject:{unlocked:0}},
            solution:{nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}},
            conflict:{seat:{unlocked:0}, shop:{unlocked:0}, shovel:{unlocked:0}, stand:{unlocked:0}, photo:{unlocked:0}},
            advocacy:{bird:{unlocked:0}, train:{unlocked:0}, monkey:{unlocked:0}, care:{unlocked:0}, snack:{unlocked:0}},
            community:{cone:{unlocked:0}, guard:{unlocked:0}, wheel:{unlocked:0}, arcade:{unlocked:0}, food:{unlocked:0}, grocery:{unlocked:0}, salon:{unlocked:0}, clothing:{unlocked:0}, bakery:{unlocked:0}, theater:{unlocked:0}}}
        }

        let level3DecorateTempObj = action.payload?.decorate;
        if (!level3DecorateTempObj) {
            level3DecorateTempObj = {background: 0, items:[]}
        }

        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3: level3tempObj,
            level3Decorate: level3DecorateTempObj,
            level3Coin: action.payload?.coin ? action.payload?.coin : 0,
          },
        };
      }

      case 'SET_FREEPLAY_LEVEL4_INITIALSTATE': {  
        let level4tempObj = action.payload?.progress;
        if (!level4tempObj) {
            level4tempObj = {favorite:{candy:{unlocked:0}, movie:{unlocked:0}, song:{unlocked:0}, game:{unlocked:0}, book:{unlocked:0}, chatChallenge:{unlocked:0}}, 
            feeling:{happy:{unlocked:0}, nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, calm:{unlocked:0}, confident:{unlocked:0}, chatChallenge:{unlocked:0}},
            listening:{happy:{unlocked:0}, nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, calm:{unlocked:0}, confident:{unlocked:0}, chatChallenge:{unlocked:0}},
            friends:{thing:{unlocked:0}, family:{unlocked:0}, place:{unlocked:0}, holiday:{unlocked:0}, relax:{unlocked:0}, chatChallenge:{unlocked:0}},
            solution:{nervous:{unlocked:0}, sad:{unlocked:0}, mad:{unlocked:0}, chatChallenge:{completed:0}},
            conflict:{lunch:{unlocked:0}, recess:{unlocked:0}, line:{unlocked:0}, project:{unlocked:0}, hurt:{unlocked:0}, chatChallenge:{unlocked:0}},
            advocacy:{bird:{unlocked:0}, train:{unlocked:0}, direction:{unlocked:0}, help:{unlocked:0}, snack:{unlocked:0}, chatChallenge:{unlocked:0}},
            community:{cone:{unlocked:0}, guard:{unlocked:0}, food:{unlocked:0}, salon:{unlocked:0}, bakery:{unlocked:0}, theater:{unlocked:0}, chatChallenge:{unlocked:0}},
            }
        }

        let level4DecorateTempObj = action.payload?.decorate;
        if (!level4DecorateTempObj) {
            level4DecorateTempObj = {background: 0, items:[]}
        }

        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level4: level4tempObj,
            level4Decorate: level4DecorateTempObj,
            level4Coin: action.payload?.coin ? action.payload?.coin : 0,
          },
        };
      }

      case 'CLEAR': {
        return {
          ...freeplayInitialState,
        };
      }

      case 'FREEPLAY_SET_COIN': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            coins: action.payload,
          },
        };
      }

      case 'FREEPLAY_SET_STUDENT_NAME': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            studentName: action.payload,
          },
        };
      }

      case 'FREEPLAY_SET_FRIEND_NAME': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            friendName: action.payload,
          },
        };
      }
      case 'FREEPLAY_SET_SELECTED_STUDENT_CHARACTER': {
      //LEVEL 1
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            selectedStudentCharacter: action.payload,
          },
        };
      }

      case 'FREEPLAY_SET_SELECTED_FRIEND_CHARACTER': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            selectedFriendCharacter: action.payload,
          },
        };
      }
      
      case 'FREEPLAY_SET_LEVEL1_COIN': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1Coin: action.payload,
          },
        };
      }

      case 'FREEPLAY_SET_DECORATE_LEVEL1': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1Decorate: action.payload,
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL1_FAVORITE_COLOR': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1: {
              ...state.freeplay.level1,
              favorite: {
                ...state.freeplay.level1.favorite,
                color:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL1_FAVORITE_ANIMAL': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1: {
              ...state.freeplay.level1,
              favorite: {
                ...state.freeplay.level1.favorite,
                animal:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL1_FAVORITE_FOOD': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1: {
              ...state.freeplay.level1,
              favorite: {
                ...state.freeplay.level1.favorite,
                food:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL1_FAVORITE_GAME': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1: {
              ...state.freeplay.level1,
              favorite: {
                ...state.freeplay.level1.favorite,
                game:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL1_FAVORITE_THING': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1: {
              ...state.freeplay.level1,
              favorite: {
                ...state.freeplay.level1.favorite,
                thing:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL1_FEELING_HAPPY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    feeling: {
                        ...state.freeplay.level1.feeling,
                        happy: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FEELING_NERVOUS': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    feeling: {
                        ...state.freeplay.level1.feeling,
                        nervous: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FEELING_SAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    feeling: {
                        ...state.freeplay.level1.feeling,
                        sad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FEELING_MAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    feeling: {
                        ...state.freeplay.level1.feeling,
                        mad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FEELING_CALM': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    feeling: {
                        ...state.freeplay.level1.feeling,
                        calm: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FEELING_CONFIDENT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    feeling: {
                        ...state.freeplay.level1.feeling,
                        confident: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

      case 'FREEPLAY_SET_LEVEL1_LISTENING_HAPPY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    listening: {
                        ...state.freeplay.level1.listening,
                        happy: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_LISTENING_NERVOUS': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    listening: {
                        ...state.freeplay.level1.listening,
                        nervous: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_LISTENING_SAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    listening: {
                        ...state.freeplay.level1.listening,
                        sad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_LISTENING_MAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    listening: {
                        ...state.freeplay.level1.listening,
                        mad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_LISTENING_CALM': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    listening: {
                        ...state.freeplay.level1.listening,
                        calm: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_LISTENING_CONFIDENT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    listening: {
                        ...state.freeplay.level1.listening,
                        confident: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FRIENDS_OUTSIDE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    friends: {
                        ...state.freeplay.level1.friends,
                        outside: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FRIENDS_ANIMAL': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    friends: {
                        ...state.freeplay.level1.friends,
                        animal: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FRIENDS_FOOD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    friends: {
                        ...state.freeplay.level1.friends,
                        food: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FRIENDS_FUN': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    friends: {
                        ...state.freeplay.level1.friends,
                        fun: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_FRIENDS_SUBJECT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    friends: {
                        ...state.freeplay.level1.friends,
                        subject: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_SOLUTION_SAD': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1: {
              ...state.freeplay.level1,
              solution: {
                ...state.freeplay.level1.solution,
                sad:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }
    case 'FREEPLAY_SET_LEVEL1_SOLUTION_MAD': {
        return {
            ...state,
            freeplay: {
            ...state.freeplay,
            level1: {
                ...state.freeplay.level1,
                solution: {
                ...state.freeplay.level1.solution,
                mad:{
                    unlocked: action.payload
                }
                },
            },
            },
        };
    }
    case 'FREEPLAY_SET_LEVEL1_SOLUTION_NERVOUS': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level1: {
              ...state.freeplay.level1,
              solution: {
                ...state.freeplay.level1.solution,
                nervous:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }
    case 'FREEPLAY_SET_LEVEL1_CONFLICT_SEAT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    conflict: {
                        ...state.freeplay.level1.conflict,
                        seat: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_CONFLICT_SHOP': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    conflict: {
                        ...state.freeplay.level1.conflict,
                        shop: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_CONFLICT_SHOVEL': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    conflict: {
                        ...state.freeplay.level1.conflict,
                        shovel: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_CONFLICT_STAND': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    conflict: {
                        ...state.freeplay.level1.conflict,
                        stand: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_CONFLICT_PHOTO': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    conflict: {
                        ...state.freeplay.level1.conflict,
                        photo: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_ADVOCACY_BIRD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    advocacy: {
                        ...state.freeplay.level1.advocacy,
                        bird: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_ADVOCACY_TRAIN': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    advocacy: {
                        ...state.freeplay.level1.advocacy,
                        train: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_ADVOCACY_MONKEY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    advocacy: {
                        ...state.freeplay.level1.advocacy,
                        monkey: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_ADVOCACY_CARE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    advocacy: {
                        ...state.freeplay.level1.advocacy,
                        care: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_ADVOCACY_SNACK': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    advocacy: {
                        ...state.freeplay.level1.advocacy,
                        snack: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_CONE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    community: {
                        ...state.freeplay.level1.community,
                        cone: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_GUARD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    community: {
                        ...state.freeplay.level1.community,
                        guard: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_WHEEL': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    community: {
                        ...state.freeplay.level1.community,
                        wheel: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_ARCADE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    community: {
                        ...state.freeplay.level1.community,
                        arcade: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_FOOD': {
      return {
          ...state,
          freeplay: {
              ...state.freeplay,
              level1: {
                  ...state.freeplay.level1,
                  community: {
                      ...state.freeplay.level1.community,
                      food: {
                          unlocked: action.payload
                      }
                  }
              }
          }
      };
    }

    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_GROCERY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    community: {
                        ...state.freeplay.level1.community,
                        grocery: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_SALON': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    community: {
                        ...state.freeplay.level1.community,
                        salon: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_CLOTHING': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    community: {
                        ...state.freeplay.level1.community,
                        clothing: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_BAKERY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level1: {
                    ...state.freeplay.level1,
                    community: {
                        ...state.freeplay.level1.community,
                        bakery: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL1_COMMUNITY_THEATER': {
      return {
          ...state,
          freeplay: {
              ...state.freeplay,
              level1: {
                  ...state.freeplay.level1,
                  community: {
                      ...state.freeplay.level1.community,
                      theater: {
                          unlocked: action.payload
                      }
                  }
              }
          }
      };
    }

        //LEVEL 2
        case 'FREEPLAY_SET_LEVEL2_COIN': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2Coin: action.payload,
            },
            };
        }

        case 'FREEPLAY_SET_LEVEL2_SHAREDCOIN': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2SharedCoin: action.payload,
            },
            };
        }

        case 'FREEPLAY_SET_DECORATE_LEVEL2': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2Decorate: action.payload,
            },
            };
        }

        case 'FREEPLAY_SET_LEVEL2_FAVORITE_COLOR': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2: {
                ...state.freeplay.level2,
                favorite: {
                    ...state.freeplay.level2.favorite,
                    color:{
                    unlocked: action.payload
                    }
                },
                },
            },
            };
        }

        case 'FREEPLAY_SET_LEVEL2_FAVORITE_ANIMAL': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2: {
                ...state.freeplay.level2,
                favorite: {
                    ...state.freeplay.level2.favorite,
                    animal:{
                    unlocked: action.payload
                    }
                },
                },
            },
            };
        }

        case 'FREEPLAY_SET_LEVEL2_FAVORITE_FOOD': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2: {
                ...state.freeplay.level2,
                favorite: {
                    ...state.freeplay.level2.favorite,
                    food:{
                    unlocked: action.payload
                    }
                },
                },
            },
            };
        }

        case 'FREEPLAY_SET_LEVEL2_FAVORITE_GAME': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2: {
                ...state.freeplay.level2,
                favorite: {
                    ...state.freeplay.level2.favorite,
                    game:{
                    unlocked: action.payload
                    }
                },
                },
            },
            };
        }

        case 'FREEPLAY_SET_LEVEL2_FAVORITE_THING': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2: {
                ...state.freeplay.level2,
                favorite: {
                    ...state.freeplay.level2.favorite,
                    thing:{
                    unlocked: action.payload
                    }
                },
                },
            },
            };
        }

        case 'FREEPLAY_SET_LEVEL2_FEELING_HAPPY': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        feeling: {
                            ...state.freeplay.level2.feeling,
                            happy: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FEELING_NERVOUS': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        feeling: {
                            ...state.freeplay.level2.feeling,
                            nervous: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FEELING_SAD': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        feeling: {
                            ...state.freeplay.level2.feeling,
                            sad: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FEELING_MAD': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        feeling: {
                            ...state.freeplay.level2.feeling,
                            mad: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FEELING_CALM': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        feeling: {
                            ...state.freeplay.level2.feeling,
                            calm: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FEELING_CONFIDENT': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        feeling: {
                            ...state.freeplay.level2.feeling,
                            confident: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }

        case 'FREEPLAY_SET_LEVEL2_LISTENING_HAPPY': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        listening: {
                            ...state.freeplay.level2.listening,
                            happy: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_LISTENING_NERVOUS': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        listening: {
                            ...state.freeplay.level2.listening,
                            nervous: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_LISTENING_SAD': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        listening: {
                            ...state.freeplay.level2.listening,
                            sad: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_LISTENING_MAD': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        listening: {
                            ...state.freeplay.level2.listening,
                            mad: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_LISTENING_CALM': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        listening: {
                            ...state.freeplay.level2.listening,
                            calm: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_LISTENING_CONFIDENT': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        listening: {
                            ...state.freeplay.level2.listening,
                            confident: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FRIENDS_OUTSIDE': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        friends: {
                            ...state.freeplay.level2.friends,
                            outside: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FRIENDS_ANIMAL': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        friends: {
                            ...state.freeplay.level2.friends,
                            animal: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FRIENDS_FOOD': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        friends: {
                            ...state.freeplay.level2.friends,
                            food: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FRIENDS_FUN': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        friends: {
                            ...state.freeplay.level2.friends,
                            fun: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_FRIENDS_SUBJECT': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        friends: {
                            ...state.freeplay.level2.friends,
                            subject: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_SOLUTION_SAD': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2: {
                ...state.freeplay.level2,
                solution: {
                    ...state.freeplay.level2.solution,
                    sad:{
                    unlocked: action.payload
                    }
                },
                },
            },
            };
        }
        case 'FREEPLAY_SET_LEVEL2_SOLUTION_MAD': {
            return {
                ...state,
                freeplay: {
                ...state.freeplay,
                level2: {
                    ...state.freeplay.level2,
                    solution: {
                    ...state.freeplay.level2.solution,
                    mad:{
                        unlocked: action.payload
                    }
                    },
                },
                },
            };
        }
        case 'FREEPLAY_SET_LEVEL2_SOLUTION_NERVOUS': {
            return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2: {
                ...state.freeplay.level2,
                solution: {
                    ...state.freeplay.level2.solution,
                    nervous:{
                    unlocked: action.payload
                    }
                },
                },
            },
            };
        }
        case 'FREEPLAY_SET_LEVEL2_CONFLICT_SEAT': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        conflict: {
                            ...state.freeplay.level2.conflict,
                            seat: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_CONFLICT_SHOP': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        conflict: {
                            ...state.freeplay.level2.conflict,
                            shop: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_CONFLICT_SHOVEL': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        conflict: {
                            ...state.freeplay.level2.conflict,
                            shovel: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_CONFLICT_STAND': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        conflict: {
                            ...state.freeplay.level2.conflict,
                            stand: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_CONFLICT_PHOTO': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        conflict: {
                            ...state.freeplay.level2.conflict,
                            photo: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_ADVOCACY_BIRD': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        advocacy: {
                            ...state.freeplay.level2.advocacy,
                            bird: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_ADVOCACY_TRAIN': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        advocacy: {
                            ...state.freeplay.level2.advocacy,
                            train: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_ADVOCACY_MONKEY': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        advocacy: {
                            ...state.freeplay.level2.advocacy,
                            monkey: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_ADVOCACY_CARE': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        advocacy: {
                            ...state.freeplay.level2.advocacy,
                            care: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_ADVOCACY_SNACK': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        advocacy: {
                            ...state.freeplay.level2.advocacy,
                            snack: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_CONE': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            cone: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_GUARD': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            guard: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_WHEEL': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            wheel: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_ARCADE': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            arcade: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }

        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_FOOD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level2: {
                    ...state.freeplay.level2,
                    community: {
                        ...state.freeplay.level2.community,
                        food: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
        }

        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_GROCERY': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            grocery: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_SALON': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            salon: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_CLOTHING': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            clothing: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }
        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_BAKERY': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            bakery: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }

        case 'FREEPLAY_SET_LEVEL2_COMMUNITY_THEATER': {
            return {
                ...state,
                freeplay: {
                    ...state.freeplay,
                    level2: {
                        ...state.freeplay.level2,
                        community: {
                            ...state.freeplay.level2.community,
                            theater: {
                                unlocked: action.payload
                            }
                        }
                    }
                }
            };
        }

      //LEVEL 3
      case 'FREEPLAY_SET_LEVEL3_COIN': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3Coin: action.payload,
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL3_SHAREDCOIN': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3SharedCoin: action.payload,
          },
        };
      }

      case 'FREEPLAY_SET_DECORATE_LEVEL3': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3Decorate: action.payload,
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL3_FAVORITE_COLOR': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3: {
              ...state.freeplay.level3,
              favorite: {
                ...state.freeplay.level3.favorite,
                color:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL3_FAVORITE_ANIMAL': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3: {
              ...state.freeplay.level3,
              favorite: {
                ...state.freeplay.level3.favorite,
                animal:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL3_FAVORITE_FOOD': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3: {
              ...state.freeplay.level3,
              favorite: {
                ...state.freeplay.level3.favorite,
                food:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL3_FAVORITE_GAME': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3: {
              ...state.freeplay.level3,
              favorite: {
                ...state.freeplay.level3.favorite,
                game:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL3_FAVORITE_THING': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3: {
              ...state.freeplay.level3,
              favorite: {
                ...state.freeplay.level3.favorite,
                thing:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }

      case 'FREEPLAY_SET_LEVEL3_FEELING_HAPPY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    feeling: {
                        ...state.freeplay.level3.feeling,
                        happy: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FEELING_NERVOUS': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    feeling: {
                        ...state.freeplay.level3.feeling,
                        nervous: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FEELING_SAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    feeling: {
                        ...state.freeplay.level3.feeling,
                        sad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FEELING_MAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    feeling: {
                        ...state.freeplay.level3.feeling,
                        mad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FEELING_CALM': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    feeling: {
                        ...state.freeplay.level3.feeling,
                        calm: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FEELING_CONFIDENT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    feeling: {
                        ...state.freeplay.level3.feeling,
                        confident: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

      case 'FREEPLAY_SET_LEVEL3_LISTENING_HAPPY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    listening: {
                        ...state.freeplay.level3.listening,
                        happy: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_LISTENING_NERVOUS': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    listening: {
                        ...state.freeplay.level3.listening,
                        nervous: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_LISTENING_SAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    listening: {
                        ...state.freeplay.level3.listening,
                        sad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_LISTENING_MAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    listening: {
                        ...state.freeplay.level3.listening,
                        mad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_LISTENING_CALM': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    listening: {
                        ...state.freeplay.level3.listening,
                        calm: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_LISTENING_CONFIDENT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    listening: {
                        ...state.freeplay.level3.listening,
                        confident: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FRIENDS_OUTSIDE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    friends: {
                        ...state.freeplay.level3.friends,
                        outside: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FRIENDS_ANIMAL': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    friends: {
                        ...state.freeplay.level3.friends,
                        animal: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FRIENDS_FOOD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    friends: {
                        ...state.freeplay.level3.friends,
                        food: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FRIENDS_FUN': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    friends: {
                        ...state.freeplay.level3.friends,
                        fun: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_FRIENDS_SUBJECT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    friends: {
                        ...state.freeplay.level3.friends,
                        subject: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_SOLUTION_SAD': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3: {
              ...state.freeplay.level3,
              solution: {
                ...state.freeplay.level3.solution,
                sad:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }
    case 'FREEPLAY_SET_LEVEL3_SOLUTION_MAD': {
        return {
            ...state,
            freeplay: {
            ...state.freeplay,
            level3: {
                ...state.freeplay.level3,
                solution: {
                ...state.freeplay.level3.solution,
                mad:{
                    unlocked: action.payload
                }
                },
            },
            },
        };
    }
    case 'FREEPLAY_SET_LEVEL3_SOLUTION_NERVOUS': {
        return {
          ...state,
          freeplay: {
            ...state.freeplay,
            level3: {
              ...state.freeplay.level3,
              solution: {
                ...state.freeplay.level3.solution,
                nervous:{
                  unlocked: action.payload
                }
              },
            },
          },
        };
      }
    case 'FREEPLAY_SET_LEVEL3_CONFLICT_SEAT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    conflict: {
                        ...state.freeplay.level3.conflict,
                        seat: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_CONFLICT_SHOP': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    conflict: {
                        ...state.freeplay.level3.conflict,
                        shop: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_CONFLICT_SHOVEL': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    conflict: {
                        ...state.freeplay.level3.conflict,
                        shovel: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_CONFLICT_STAND': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    conflict: {
                        ...state.freeplay.level3.conflict,
                        stand: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_CONFLICT_PHOTO': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    conflict: {
                        ...state.freeplay.level3.conflict,
                        photo: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_ADVOCACY_BIRD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    advocacy: {
                        ...state.freeplay.level3.advocacy,
                        bird: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_ADVOCACY_TRAIN': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    advocacy: {
                        ...state.freeplay.level3.advocacy,
                        train: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_ADVOCACY_MONKEY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    advocacy: {
                        ...state.freeplay.level3.advocacy,
                        monkey: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_ADVOCACY_CARE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    advocacy: {
                        ...state.freeplay.level3.advocacy,
                        care: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_ADVOCACY_SNACK': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    advocacy: {
                        ...state.freeplay.level3.advocacy,
                        snack: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_CONE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    community: {
                        ...state.freeplay.level3.community,
                        cone: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_GUARD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    community: {
                        ...state.freeplay.level3.community,
                        guard: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_WHEEL': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    community: {
                        ...state.freeplay.level3.community,
                        wheel: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_ARCADE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    community: {
                        ...state.freeplay.level3.community,
                        arcade: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_FOOD': {
      return {
          ...state,
          freeplay: {
              ...state.freeplay,
              level3: {
                  ...state.freeplay.level3,
                  community: {
                      ...state.freeplay.level3.community,
                      food: {
                          unlocked: action.payload
                      }
                  }
              }
          }
      };
    }

    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_GROCERY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    community: {
                        ...state.freeplay.level3.community,
                        grocery: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_SALON': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    community: {
                        ...state.freeplay.level3.community,
                        salon: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_CLOTHING': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    community: {
                        ...state.freeplay.level3.community,
                        clothing: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_BAKERY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level3: {
                    ...state.freeplay.level3,
                    community: {
                        ...state.freeplay.level3.community,
                        bakery: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL3_COMMUNITY_THEATER': {
      return {
          ...state,
          freeplay: {
              ...state.freeplay,
              level3: {
                  ...state.freeplay.level3,
                  community: {
                      ...state.freeplay.level3.community,
                      theater: {
                          unlocked: action.payload
                      }
                  }
              }
          }
      };
    }

    //LEVEL 4
    case 'FREEPLAY_SET_LEVEL4_COIN': {
        return {
        ...state,
        freeplay: {
            ...state.freeplay,
            level4Coin: action.payload,
        },
        };
    }

    case 'FREEPLAY_SET_LEVEL4_SHAREDCOIN': {
        return {
        ...state,
        freeplay: {
            ...state.freeplay,
            level4SharedCoin: action.payload,
        },
        };
    }

    case 'FREEPLAY_SET_DECORATE_LEVEL4': {
        return {
        ...state,
        freeplay: {
            ...state.freeplay,
            level4Decorate: action.payload,
        },
        };
    }

    case 'FREEPLAY_SET_LEVEL4_FAVORITE_CANDY': {
        return {
        ...state,
        freeplay: {
            ...state.freeplay,
            level4: {
            ...state.freeplay.level4,
            favorite: {
                ...state.freeplay.level4.favorite,
                candy:{
                unlocked: action.payload
                }
            },
            },
        },
        };
    }

    case 'FREEPLAY_SET_LEVEL4_FAVORITE_MOVIE': {
        return {
        ...state,
        freeplay: {
            ...state.freeplay,
            level4: {
            ...state.freeplay.level4,
            favorite: {
                ...state.freeplay.level4.favorite,
                movie:{
                unlocked: action.payload
                }
            },
            },
        },
        };
    }

    case 'FREEPLAY_SET_LEVEL4_FAVORITE_SONG': {
        return {
        ...state,
        freeplay: {
            ...state.freeplay,
            level4: {
            ...state.freeplay.level4,
            favorite: {
                ...state.freeplay.level4.favorite,
                song:{
                unlocked: action.payload
                }
            },
            },
        },
        };
    }

    case 'FREEPLAY_SET_LEVEL4_FAVORITE_GAME': {
        return {
        ...state,
        freeplay: {
            ...state.freeplay,
            level4: {
            ...state.freeplay.level4,
            favorite: {
                ...state.freeplay.level4.favorite,
                game:{
                unlocked: action.payload
                }
            },
            },
        },
        };
    }

    case 'FREEPLAY_SET_LEVEL4_FAVORITE_BOOK': {
        return {
        ...state,
        freeplay: {
            ...state.freeplay,
            level4: {
            ...state.freeplay.level4,
            favorite: {
                ...state.freeplay.level4.favorite,
                book:{
                unlocked: action.payload
                }
            },
            },
        },
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FEELING_HAPPY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    feeling: {
                        ...state.freeplay.level4.feeling,
                        happy: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FEELING_NERVOUS': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    feeling: {
                        ...state.freeplay.level4.feeling,
                        nervous: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FEELING_SAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    feeling: {
                        ...state.freeplay.level4.feeling,
                        sad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FEELING_MAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    feeling: {
                        ...state.freeplay.level4.feeling,
                        mad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FEELING_CALM': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    feeling: {
                        ...state.freeplay.level4.feeling,
                        calm: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FEELING_CONFIDENT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    feeling: {
                        ...state.freeplay.level4.feeling,
                        confident: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

      case 'FREEPLAY_SET_LEVEL4_LISTENING_HAPPY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    listening: {
                        ...state.freeplay.level4.listening,
                        happy: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_LISTENING_NERVOUS': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    listening: {
                        ...state.freeplay.level4.listening,
                        nervous: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_LISTENING_SAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    listening: {
                        ...state.freeplay.level4.listening,
                        sad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_LISTENING_MAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    listening: {
                        ...state.freeplay.level4.listening,
                        mad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_LISTENING_CALM': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    listening: {
                        ...state.freeplay.level4.listening,
                        calm: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_LISTENING_CONFIDENT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    listening: {
                        ...state.freeplay.level4.listening,
                        confident: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FRIENDS_THING': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    friends: {
                        ...state.freeplay.level4.friends,
                        thing: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FRIENDS_FAMILY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    friends: {
                        ...state.freeplay.level4.friends,
                        family: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FRIENDS_PLACE': { 
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    friends: {
                        ...state.freeplay.level4.friends,
                        place: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FRIENDS_HOLIDAY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    friends: {
                        ...state.freeplay.level4.friends,
                        holiday: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_FRIENDS_RELAX': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    friends: {
                        ...state.freeplay.level4.friends,
                        relax: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_SOLUTION_NERVOUS': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    solution: {
                        ...state.freeplay.level4.solution,
                        nervous: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_SOLUTION_SAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    solution: {
                        ...state.freeplay.level4.solution,
                        sad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_SOLUTION_MAD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    solution: {
                        ...state.freeplay.level4.solution,
                        mad: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_CONFLICT_LUNCH': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    conflict: {
                        ...state.freeplay.level4.conflict,
                        lunch: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_CONFLICT_RECESS': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    conflict: {
                        ...state.freeplay.level4.conflict,
                        recess: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_CONFLICT_LINE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    conflict: {
                        ...state.freeplay.level4.conflict,
                        line: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_CONFLICT_PROJECT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    conflict: {
                        ...state.freeplay.level4.conflict,      
                        project: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_CONFLICT_HURT': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    conflict: {
                        ...state.freeplay.level4.conflict,
                        hurt: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_ADVOCACY_BIRD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    advocacy: {
                        ...state.freeplay.level4.advocacy,
                        bird: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_ADVOCACY_TRAIN': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    advocacy: {
                        ...state.freeplay.level4.advocacy,
                        train: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_ADVOCACY_DIRECTION': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    advocacy: {
                        ...state.freeplay.level4.advocacy,
                        direction: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_ADVOCACY_HELP': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    advocacy: {
                        ...state.freeplay.level4.advocacy,  
                        help: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_ADVOCACY_SNACK': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    advocacy: {
                        ...state.freeplay.level4.advocacy,
                        snack: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_COMMUNITY_CONE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    community: {
                        ...state.freeplay.level4.community,  
                        cone: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_COMMUNITY_GUARD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,  
                    community: {
                        ...state.freeplay.level4.community,
                        guard: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_COMMUNITY_FOOD': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    community: {
                        ...state.freeplay.level4.community,
                        food: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_COMMUNITY_SALON': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    community: {    
                        ...state.freeplay.level4.community,
                        salon: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_COMMUNITY_BAKERY': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    community: {
                        ...state.freeplay.level4.community,
                        bakery: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }
    case 'FREEPLAY_SET_LEVEL4_COMMUNITY_THEATER': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    community: {
                        ...state.freeplay.level4.community,
                        theater: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    // Chat Challenge Completion Actions
    case 'FREEPLAY_SET_LEVEL4_FAVORITE_CHAT_CHALLENGE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    favorite: {
                        ...state.freeplay.level4.favorite,
                        chatChallenge: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL4_FEELING_CHAT_CHALLENGE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    feeling: {
                        ...state.freeplay.level4.feeling,
                        chatChallenge: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL4_LISTENING_CHAT_CHALLENGE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    listening: {
                        ...state.freeplay.level4.listening,
                        chatChallenge: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL4_FRIENDS_CHAT_CHALLENGE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    friends: {
                        ...state.freeplay.level4.friends,
                        chatChallenge: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL4_SOLUTION_CHAT_CHALLENGE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    solution: {
                        ...state.freeplay.level4.solution,
                        chatChallenge: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL4_CONFLICT_CHAT_CHALLENGE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    conflict: {
                        ...state.freeplay.level4.conflict,
                        chatChallenge: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL4_ADVOCACY_CHAT_CHALLENGE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    advocacy: {
                        ...state.freeplay.level4.advocacy,
                        chatChallenge: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    case 'FREEPLAY_SET_LEVEL4_COMMUNITY_CHAT_CHALLENGE': {
        return {
            ...state,
            freeplay: {
                ...state.freeplay,
                level4: {
                    ...state.freeplay.level4,
                    community: {
                        ...state.freeplay.level4.community,
                        chatChallenge: {
                            unlocked: action.payload
                        }
                    }
                }
            }
        };
    }

    default:
      return state;
    }
  };
  export default FreePlayReducer;
  